<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        审批历史
        <small>审批历史</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 审批历史
          </a>
        </li>
        <li class="active">审批历史</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="col-sm-12">
        <div id="atptoolbar">
          <!--                    <button class="btn btn-warning" type="button" id="sys_judge" @click="judge">-->
          <!--                        <i class="fa fa-pencil"></i>&nbsp;审批-->
          <!--                    </button>-->
        </div>
        <table id="approval_list_table"></table>
      </div>
    </section>
    <!-- /.content -->
    <v-advancesearch></v-advancesearch>
  </div>
</template>

<script>
import advancesearch from './advancedsearch'

export default {
  name: 'approvalList',
  data() {
    return {
      instanceid: '' // 审批流实例ID
    }
  },
  components: {
    'v-advancesearch': advancesearch
  },
  mounted: function () {
    // 获取所有的审批历史
    var self = this
    console.log('___请求审批历史数据')
    $('#approval_list_table').bootstrapTable({
      url: self.global.apiHost + 'approval_record/',
      method: 'get', // 请求方式（*）
      ajaxOptions: {
        headers: {
          'content-type': 'application/json', // 默认值
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        }
      },
      toolbar: '#atptoolbar', // 工具按钮用哪个容器
      height: $(window).height() * 0.86,
      striped: true, // 是否显示行间隔色
      cache: false, // 是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
      pagination: true, // 是否显示分页（*）
      iconSize: 'outline',
      sortable: true, // 是否启用排序
      sortName: 'id',
      sortOrder: 'DESC', // 排序方式
      queryParams: self.queryParams, // 传递参数（*）
      sidePagination: 'server', // 分页方式：client客户端分页，server服务端分页（*）
      pageNumber: 1, // 初始化加载第一页，默认第一页
      pageSize: 10, // 每页的记录行数（*）
      pageList: [10], // 可供选择的每页的行数（*）
      // search: true, // 是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
      showColumns: true, // 是否显示所有的列
      showRefresh: true, // 是否显示刷新按钮
      minimumCountColumns: 2, // 最少允许的列数
      clickToSelect: true, // 是否启用点击选中行
      singleSelect: true, // 是否启用单选
      uniqueId: 'id', // 每一行的唯一标识，一般为主键列
      responseHandler: function (res) {
        console.log('___获取到数据', res)
        return {
          total: res.total, // 总页数
          rows: res.rows // 数据
        }
      },
      columns: [
        [
          {checkbox: true},
          {
            title: '申请单号',
            width: 40,
            field: 'instance_id'
          },
          {
            title: '创建时间',
            width: 40,
            field: 'create_at'
          },
          {
            title: '流程ID',
            width: 40,
            field: 'define_id'
          },
          {
            title: '节点名称',
            width: 40,
            field: 'node_name'
          },
          {
            title: '审批结果',
            width: 40,
            field: 'result'
          },
        ]
      ]
    })
  },
  methods: {
    queryParams: function (param) {
      console.log()
      // param.org_id = JSON.parse(localStorage.getItem('companyInfo')).id
      param.per_page = param.limit
      param.page = param.offset / param.limit + 1
      return param
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/approvalCenter/approvalRecord.vue